module.exports = __webpack_public_path__ + "img/icon-09-subscriptionAsset 15.757a3101.svg";